const EN = {
    "Admin Login": "Admin Login",
    "Username": 'Username',
    "Enter Username": "Enter Username",
    "Password": "Password",
    "Enter Password": "Enter Password",
    "Remember me": "Remember me",
    "Login": "Login",
    "This field is required.": "This field is required.",
    "Error": "Error",
    "Invalid email or password": 'Invalid email or password',
    "The page you were looking for is not found!": "The page you were looking for is not found!",
    "Dashboard": "Dashboard",
    "Member": "Member",
    "Member Details": "Member Details",
    "Lookup Sponsor": "Lookup Sponsor",
    "Direct Downline": "Direct Downline",
    "Overall Team Hierarchy": "Overall Team Hierarchy",
    "Member KYC": "Member KYC",
    "Rank Log": "Rank Log",
    "Wallet": "Wallet",
    "Wallet Transaction": "Wallet Transaction",
    "CRM Withdrawal": "CRM Withdrawal",
    "CRM Deposit": "CRM Deposit",
    "MT5 Deposit": "MT5 Deposit",
    "Wallet Balance": "Wallet Balance",
    "Wallet Adjust": 'Wallet Adjust',
    "Bonus": "Bonus",
    "Lot Rebate Bonus": "Lot Rebate Bonus",
    "Same Rank Bonus": "Same Rank Bonus",
    "Contract Commission": 'Contract Commission',
    "MT5": "MT5",
    "MT5 Account": "MT5 Account",
    "Investment Record": "Investment Record",
    "System": "System",
    "Admin": "Admin",
    "OTC Tag List": "OTC Tag List",
    "Announcement": "Announcement",
    "Admin Dashboard": "Admin Dashboard",
    "Upload Profit": "Upload Profit",
    "Add Admin White List IP Address": "Add Admin White List IP Address",
    "Change Password": 'Change Password',
    "Total Register Account": "Total Register Account",
    "Total Deposit Account": "Total Deposit Account",
    "Total MT5 Balance": "Total MT5 Balance",
    "Total Wallet Balance": "Total Wallet Balance",
    "Total Withdraw Amount": "Total Withdraw Amount",
    "Personal Information": "Personal Information",
    "Enter Member Email": "Enter Member Email",
    "From": "From",
    "To": "To",
    "Download Excel": "Download Excel",
    "Status": "Status",
    "Result Per Page": "Result Per Page",
    "No options available": "No options available",
    "Register Date": "Register Date",
    "Member Email": "Member Email",
    "Referral Code": "Referral Code",
    "Referral By": "Referral By",
    "Auto Rank": "Auto Rank",
    "Manual Rank": "Manual Rank",
    "MT5 Balance": "MT5 Balance",
    "Self Deposit": "Self Deposit",
    "Personal Sales": "Personal Sales",
    "Group Sales": "Group Sales",
    "Remark": "Remark",
    "KYC Status": 'KYC Status',
    "Not Verified": "Not Verified",
    "Verified": "Verified",
    "Rejected": "Rejected",
    "Approved": "Approved",
    "Edit": "Edit",
    "Purchase Package": "Purchase Package",
    "Adjust Profit": "Adjust Profit",
    "Topup Wallet": "Top Up Wallet",
    "Reset Login Password": "Reset Login Password",
    "Reset Trx Password": "Reset Trx Password",
    "Oops! No data found...": "Oops! No data found...",
    "Registration Date": "Registration Date",
    "Name": "Name",
    "Enter Name": "Enter Name",
    "Email": "Email",
    "Enter Email": "Enter Email",
    "Sponsor Name": "Sponsor Name",
    "Select Sponsor Name": "Select Sponsor Name",
    "Select Ranking": "Select Ranking",
    "Date of Birth": 'Date of Birth',
    "Select Date Of Birth": "Select Date Of Birth",
    "Phone No": "Phone No",
    "Enter Phone No": "Enter Phone No",
    "Country": "Country",
    "Select Country": "Select Country",
    "Address": "Address",
    "Enter Address": "Enter Address",
    "Confirm": "Confirm",
    "Add Member": "Add Member",
    "Wallet Address": "Wallet Address",
    "Enter Wallet Address": "Enter Wallet Address",
    "Trx Password": "Trx Password",
    "Enter Trx Password": "Enter Trx Password",
    "Confirm Trx Password": "Confirm Trx Password",
    "Enter Confirm Trx Password": "Enter Confirm Trx Password",
    "Enter Referral Code": "Enter Referral Code",
    "Transfer": "Transfer",
    "Topup": "Top Up",
    "Package": "Package",
    "Select Package": "Select Package",
    "Monthly Return": "Monthly Return",
    "Select MT5 Account": "Select MT5 Account",
    "Topup Amount": 'Top Up Amount',
    "Select Topup Amount": "Select Top Up Amount",
    "Extra Profit": 'Extra Profit',
    "Contract Period": "Contract Period",
    "Select Contract Period": 'Select Contract Period',
    "Days": "Days",
    "Total Profit": "Total Profit",
    "Enter Total Profit": "Enter Total Profit",
    "Total Commission": "Total Commission",
    "Enter Total Commission": "Enter Total Commission",
    "Topup Wallet Amount": "Top Up Wallet Amount",
    "Select Topup Wallet Amount": "Select Top Up Wallet Amount",
    "New Login Password": "New Login Password",
    "Enter New Login Password": "Enter New Login Password",
    "Confirm New Login Password": "Confirm New Login Password",
    "Enter Confirm New Login Password": "Enter Confirm New Login Password",
    "New Trx Password": "New Trx Password",
    "Enter New Trx Password": "Enter New Trx Password",
    "Confirm New Trx Password": "Confirm New Trx Password",
    "Active": "Active",
    "Inactive": "Inactive",
    "KYC Verified": "KYC Verified",
    "Attention": "Attention",
    "Do you want to remove this member?": "Do you want to remove this member?",
    "Ok": "Ok",
    "Cancel": "Cancel",
    "Success": "Success",
    "Confirm trx password need to same with new trx password": "Confirm trx password need to same with new trx password",
    "Confirm login password need to same with new login password.": "Confirm login password need to same with new login password.",
    "Drag 'n' drop an Excel file here, or click to select one": "Drag 'n' drop an Excel file here, or click to select one",
    "Selected file": "Selected file",
    "Upload": "Upload",
    "Manual Update Profit": "Manual Update Profit",
    "Download Sample File": "Download Sample File",
    "Download": "Download",
    "Code": "Code",
    "Only Excel files (.xlsx, .xls) are accepted.": 'Only Excel files (.xlsx, .xls) are accepted.',
    "Personal CRM Deposit": "Personal CRM Deposit",
    "Group CRM Deposit": "Group CRM Deposit",
    "Personal (Search By Email)": "Personal (Search By Email)",
    "Group (Search By Email)": "Group (Search By Email)",
    "Transaction Date": "Transaction Date",
    "Wallet Type": 'Wallet Type',
    "Transaction Type": "Transaction Type",
    "Transaction Desc": "Transaction Desc",
    "Amount": 'Amount',
    "Personal MT5 Deposit": "Personal MT5 Deposit",
    "Group MT5 Deposit": "Group MT5 Deposit",
    "Total Downline": "Total Downline",
    "Active Downline": "Active Downline",
    "Total Member": "Total Member",
    "Total Active Member": "Total Active Member",
    "Total Sales": "Total Sales",
    "Personal Deposit": "Personal Deposit",
    "Process Date": "Process Date",
    "Original Rank": "Original Rank",
    "New Rank": "New Rank",
    "Add Admin": "Add Admin",
    "Login Username": "Login Username",
    "Deactivate": "Deactivate",
    "Activate": 'Activate',
    "Enter Login Username": "Enter Login Username",
    "Enter Login Password": "Enter Login Password",
    "Login Password": "Login Password",
    "Confirm Login Password": "Confirm Login Password",
    "Save": 'Save',
    "Edit Admin": "Edit Admin",
    "Update": "Update",
    "Do you want to deactivate this admin?": 'Do you want to deactivate this admin?',
    "Do you want to activate this admin?": "Do you want to activate this admin?",
    "Password must at least 6 characters": "Password must at least 6 characters",
    "Confirm password need to same with password": "Confirm password need to same with password",
    "Run Lot Rebate Bonus": "Run Lot Rebate Bonus",
    "Run Profit Sharing Bonus": "Run Profit Sharing Bonus",
    "Run": "Run",
    "Generate Fake Trade Record": "Generate Fake Trade Record",
    "Select Date": "Select Date",
    "Change Percentage For Fake Trade Record": "Change Percentage For Fake Trade Record",
    "Percentage For Generate Trade Record": "Percentage For Generate Trade Record",
    "Change Exchange Rate": "Change Exchange Rate",
    "Exchange Rate System Get": "Exchange Rate System Get",
    "Exchange Rate Manually Set": "Exchange Rate Manually Set",
    "If 0 Then Use Exchange Rate System Get": "If 0 Then Use Exchange Rate System Get",
    "Run Up Rank": "Run Up Rank",
    "Run Get Mt5 Deal Task": "Run Get MT5 Deal Task",
    "Run Calculate Member Sales": "Run Calculate Member Sales",
    "Old Password": "Old Password",
    "New Password": "New Password",
    "Enter Old Password": "Enter Old Password",
    "Enter New Password": "Enter New Password",
    "Confirm Password": "Confirm Password",
    "Enter Confirm Password": "Enter Confirm Password",
    "Tag Usage": "Tag Usage",
    "register": "register",
    "otp_pending": "pending",
    "otp_completed": "completed",
    "otp_expired": "expired",
    "withdraw": "withdraw",
    "Tag": "Tag",
    "Add New White List IP": "Add New White List IP",
    "Created Date": "Created Date",
    "IP Address": "IP Address",
    "Description": "Description",
    "White List IP": "White List IP",
    "Enter IP Address": "Enter IP Address",
    "Enter Description": "Enter Description",
    "Personal Withdraw": "Personal Withdraw",
    "Group Withdraw": "Group Withdraw",
    "All": "All",
    "Doc No": "Doc No",
    "Submit Date": "Submit Date",
    "Submit Amount": "Submit Amount",
    "Withdraw Type": "Withdraw Type",
    "Fee": "Fee",
    "Fee In Fiat": "Fee In Fiat",
    "Rate": "Rate",
    "Receive Currency": "Receive Currency",
    "Receive Amount": "Receive Amount",
    "wallet_active": "Active",
    "wallet_pending": "Pending",
    "wallet_approved": "Approved",
    "wallet_rejected": "Rejected",
    "Approve": "Approve",
    "Reject": "Reject",
    "Wallet Withdrawal Details": "Wallet Withdrawal Details",
    "Crypto Section": "Crypto Section",
    "TxHash / Bank Reference Id": "TxHash / Bank Reference Id",
    "Chain Type": "Chain Type",
    "Enter Remark": "Enter Remark",
    "Confirm approve this request?": "Confirm approve this request?",
    "Confirm reject this request?": "Confirm reject this request?",
    "Wallet Balance List": "Wallet Balance List",
    "Total Balance": "Total Balance",
    "Full Name": "Full Name",
    "Wallet Transaction List": "Wallet Transaction List",
    "CRM In (Deposit)": "CRM In (Deposit)",
    "CRM Out (Withdraw)": "CRM Out (Withdraw)",
    "MT5 In (Deposit)": "MT5 In (Deposit)",
    "MT5 Out (Withdraw)": "MT5 Out (Withdraw)",
    "Total Bonus": "Total Bonus",
    "Profit Sharing": "Profit Sharing",
    "Re-Invest": "Re-Invest",
    "Total Lot Size": "Total Lot Size",
    "Adjust (Dummy Account)": "Adjust (Dummy Account)",
    "MT5 Out (Member)": "MT5 Out (Member)",
    "In Amount": "In Amount",
    "Out Amount": "Out Amount",
    "Adjust Type": "Adjust Type",
    "IN": "IN",
    "OUT": "OUT",
    "Loading Data": "Loading Data",
    "Logout": "Logout",
    "Id No": "Id No",
    "Front Image": "Front Image",
    "Back Image": "Back Image",
    "Hold Image": "Hold Image",
    "Verify Date": "Verify Date",
    "Reject Reason": "Reject Reason",
    "Do you want to approve this member?": "Do you want to approve this member?",
    "Do you want to reject this member?": "Do you want to reject this member?",
    "Pending": "Pending",
    "Submit": "Submit",
    "CRYPTO_WITHDRAW": "CRYPTO WITHDRAW",
    "FIAT_WITHDRAW": "FIAT WITHDRAW",
    "View": "View",
    "Process By": 'Process By',
    "Lot Rebate List": "Lot Rebate List",
    "Personal Bonus": "Personal Bonus",
    "Group Bonus": "Group Bonus",
    "Trx Date": "Trx Date",
    "Profit From": "Profit From",
    "Lot Size": "Lot Size",
    "Lot Rebate": "Lot Rebate",
    "Same Rank Bonus List": "Same Rank Bonus List",
    "MT5 Account List": "MT5 Account List",
    "Total MT5 Amount": "Total MT5 Amount",
    "Personal (Search By Email / MT5 ID)": "Personal (Search By Email / MT5 ID)",
    "Group (Search By Email / MT5 ID)": "Group (Search By Email / MT5 ID)",
    "Copy EA MT5 ID": "Copy EA MT5 ID",
    "Member Name": "Member Name",
    "MT5 Password": "MT5 Password",
    "MT5 ID": "MT5 ID",
    "MT5 Group": "MT5 Group",
    "Copy Trade Lot": "Copy Trade Lot",
    "Max Lot": "Max Lot",
    "Trx Date Time": "Trx Date Time",
    "Product Lot": "Product Lot",
    "Pipe Bonus Status": "Pipe Bonus Status",
    "Profit Sharing Status": "Profit Sharing Status",
    "MT5 Deal ID": "MT5 Deal ID",
    "Settlement No": "Settlement No",
    "Position ID": "Position ID",
    "Profit": "Profit",
    "Commission": "Commission",
    "Rate Profit": 'Rate Profit',
    "Rate Margin": "Rate Margin",
    "Market Bid": "Market Bid",
    "Market Ask": 'Market Ask',
    "Max Lot Per Week Status": "Max Lot Per Week Status",
    "Price": "Price",
    "Enter Amount": "Enter Amount",
    "Add Announcement": 'Add Announcement',
    "Title (English)": "Title (English)",
    "Title (Chinese)": "Title (Chinese)",
    "Description (English)": "Description (English)",
    "Description (Chinese)": "Description (Chinese)",
    "Enter Description (Chinese)": "Enter Description (Chinese)",
    "Enter Description (English)": "Enter Description (English)",
    "Enter Title (English)": "Enter Title (English)",
    "Enter Title (Chinese)": "Enter Title (Chinese)",
    "Date": "Date",
    "MT5 Login": "MT5 Login",
    "MT5 Profit": "MT5 Profit",
    "MT5 Volume": "MT5 Volume",
    "MT5 Name": "MT5 Name",
    "No Result Found": "No Result Found",
    "No data for download": "No data for download",
    "View Excel File": "View Excel File",
    "View Profit": "View Profit",
    "WITHDRAW": "Withdraw",
    "DEPOSIT_CRM": "Deposit Wallet",
    "DEPOSIT_MT5": "Deposit MT5",
    'Early Bird Bonus': "Early Bird Bonus",
    'VIP Bonus': "VIP Bonus",
    "Action": "Action",
    "Profit Sharing Bonus": "Profit Sharing Bonus",
    "Same Rank Percentage": "Same Rank Percentage",
    "Enter Topup Amount": "Enter Topup Amount",
    "Used Date": "Used Date",
    "Investment Allocation": "Investment Allocation",
    "Total": "Total",
    "Personal Same Rank Bonus": "Personal Same Rank Bonus",
    "Group Same Rank Bonus": "Group Same Rank Bonus",
    "Personal Contract Commission": "Personal Contract Commission",
    "Group Contract Commission": "Group Contract Commission",
    "Total Balance (Personal)": "Total Balance (Personal)",
    "Total Balance (Group)": "Total Balance (Group)",
    "Receive": "Receive",
    "TRANSFER_FROM_MT5": "Withdraw MT5",
    "Self Withdraw": "Self Withdraw",
    "news_active": "Active",
    "news_inactive": "Inactive",
    "Rank": "Rank",
    "change_transaction_password": "Change Transaction Password",
    "change_password": "Change Password",
    "Rank Type": "Type",
    "downgrade": "Downgrade",
    "upgrade": "Upgrade",
    "Hedge Position": "Hedge Position",
    "Period Extra Profit": "Period Extra Profit",
    "Personal Period Extra Profit": 'Personal Period Extra Profit',
    "Group Period Extra Profit": 'Group Period Extra Profit',
    "TRC20 Chain": "TRC20 Chain",
    "Copy": "Copy",
    "Copied": "Copied",
    "Personal Early Bird Bonus": "Personal Early Bird Bonus",
    "Group Early Bird Bonus": "Group Early Bird Bonus",
    "Personal VIP Bonus": "Personal VIP Bonus",
    "Group VIP Bonus": "Group VIP Bonus",
    "Early Bird Bonus Type": 'Bonus Type',
    "CRM Wallet": "CRM Wallet",
    "MT5 Wallet": "MT5 Wallet",
    "Select Action": "Select Action",
    "forget_password": "Forget Password",
    "Purchase Package History": "Purchase Package History",
    "Purchase Datetime": "Purchase Datetime",
    "Cumulative Investment Days": "Cumulative Investment Days",
    "Total MT5 Amount (Personal)": "Total MT5 Amount (Personal)",
    "Total MT5 Amount (Group)": "Total MT5 Amount (Group)",
    "ADJUST": "Adjust",
    "Modify By": "Modify By",
    "COPY EA MT5 ID": "Copy EA MT5 ID",
    "EA Status": "Status",
    "Enter Member MT5 Login": 'Enter Member MT5 Login',
    "Dummy Account": "Dummy Account",
    "Deleted": "Deleted",
    "New Announcement": "New Announcement",
    "Title": "Title",
    "Enter title": "Enter title",
    "Please fill in announcement for at least one language": "Please fill in announcement for at least one language",
    "Edit Announcement": "Edit Announcement",
    "Delete": "Delete",
    "Add Hedge Position": "Add Hedge Position",
    "New Hedge Position": "New Hedge Position",
    "Edit Hedge Position": "Edit Hedge Position",
    "Recommended Size": "Recommended Size",
    "Cover Image": "Cover Image",
    "Video": "Video",
    "Upload Image": "Upload Image",
    "Announcement not found": "Announcement not found",
    "Hedge Position not found": "Hedge Position not found",
    "Please fill in hedge position for at least one language": 'Please fill in hedge position for at least one language',
    "Select Video": "Select Video",
    "Video Uploaded": 'Video Uploaded',
    "Select New Video": "Select New Video",
    "Attachment is uploading": 'Attachment is uploading',
    "Total In (Adjust)": "Total In (Adjust)",
    "Total Out (Adjust)": "Total Out (Adjust)",
    "Personal Mt5 Profit": "Personal MT5 Profit",
    "Group Mt5 Profit": "Group MT5 Profit",
    "Role": "Role",
    "Permission": "Permission",
    "Permission List": "Permission List",
    "Operation Permission": "Operation Permission",
    "Page Permission": "Page Permission",
    "User": "User",
    "Setting": "Setting",
    "Select All": "Select All",
    "Edit Permission": "Edit Permission",
    "Add New Permission": "Add New Permission",
    "Role Name": "Role Name",
    "Enter Role Name": "Enter Role Name",
    "User Role": "User Role",
    "Select User Role": "Select User Role",
    "Customer": "Customer",
    "User Type": "User Type",
    "Action Type": "Action Type",
    "Admin Journal": "Admin Journal",
    "Enter Email/Username": "Enter Email/Username",
    "Shareholder": "Shareholder",
    "Add Shareholder": "Add Shareholder",
    "User Group": "User Group",
    "Early Bird Package": "Early Bird Package",
    "VIP Package": "VIP Package",
    "Company Customer Profit Sharing": "Company Customer Profit Sharing",
    "Configuration": "Configuration",
    "Package Amount": "Package Amount",
    "MT5 Amount": "MT5 Amount",
    "Hedge Amount": "Hedge Amount",
    "High Lot": "High Lot",
    "Low Lot": "Low Lot",
    "High ROI": "High ROI",
    "Low ROI": "Low ROI",
    "Account": "Account",
    "Group Name": "Group Name",
    "Commission Rate": "Commission Rate",
    "Upline Commission Rate": "Upline Commission Rate",
    "Total Account": "Total Account",
    "Company": "Company",
    "Enter Company Profit": "Enter Company Profit",
    "Enter Customer Profit": "Enter Customer Profit",
    "Penalty Rate": "Penalty Rate",
    "Total profit percentage must equal to 100": "Total profit percentage must equal to 100",
    "Early Bird Name": "Early Bird Name",
    "VIP Name": "VIP Name",
    "Rank Name": "Rank Name",
    "Rank Icon": "Rank Icon",
    "MT5 Balance Target": "MT5 Balance Target",
    "Personal Sales Target": "Personal Sales Target",
    "Group Sales Target": "Group Sales Target",
    "Contract Commission Rate": "Contract Commission Rate",
    "Same Rank Rate": "Same Rank Rate",
    "Select Setting Type": "Select Setting Type",
    "Please select setting": "Please select setting",
    "Login Type": "Login Type",
    "Enter": "Enter ",
    "Company Name": "Company Name",
    "Withdrawal No.": "Withdrawal No.",
    "Network Fee": "Network Fee",
    "TRX Transfer Amount": 'TRX Transfer Amount',
    "Minimum USDT Transfer Amount": "Minimum USDT Transfer Amount",
    "Main Admin ID": "Main Admin ID",
    "Company ID": "Company ID",
    "Ignore MT5 Login IDs": "Ignore MT5 Login IDs",
    "Main TRX Account": "Main TRX Account",
    "Public Key": "Public Key",
    "Private Key": 'Private Key',
    "base58 Address": 'base58 Address',
    "HEX Address": 'HEX Address',
    "MT5 Dummy Accounts": "MT5 Dummy Accounts",
    "Customer Dummy Accounts": 'Customer Dummy Accounts',
    "MT5 Current Login ID": 'MT5 Current Login ID',
    "Select User Group": "Select User Group",
    "Balance": "Balance",
    "Enter Balance": "Enter Balance",
    "Total USDT to Distribute": "Total USDT to Distribute",
    "Percentage": "Percentage",
    "Enter Percentage": 'Enter Percentage',
    "Add Data": "Add Data",
    "Only accept *.mp4, *flv format file": "Only accept mp4, webm, ogg, avi, mov, wmv, flv, mkv format file",
    "Add New Wallet Address": "Add New Wallet Address",
    "New Admin": "New Admin",
    "Add New Admin": "Add New Admin",
    "Admin_Deleted": "Deleted",
    "Add New Data": "Add New Data",
    "Commission Rate Type":"Commission Rate Type",
    "Upline Commission Rate Type":"Upline Commission Rate Type",
    "Penalty Rate Type": "Penalty Rate Type",
    "Same Rank Rate Type": "Same Rank Rate Type",
    "Contract Commission Rate Type": "Contract Commission Rate Type",
    "Special Account": "Early Bird/VIP List",
    "Special Account Type": "Early Bird/VIP",
    "Special Account List": "Early Bird/VIP List",
    "Early Bird Bonus Package": "Early Bird Package",
    "VIP Bonus Package": "VIP Package",
    "Add Special Account": "Add Account",
    "Change Contract Period": "Change Contract Period",
    "Current Contract Period": 'Current Contract Period',
    "New Contract Period": 'New Contract Period',
    "Order ID": "Order ID",
    "Trading Pair": "Trading Pair",
    "Profit/Loss %": "Profit/Loss %",
    "Price Enter": "Price Enter",
    "Price Close": "Price Close",
    "completed": "completed",
    "Buy": "Buy",
    "Sell": "Sell",
    "Start Date": "Start Date",
    "Total Earning Bonus": "Total Earning Bonus",
    "Admin Account Setting": "Admin Account Setting",
    "Details": "Details",
    "Data Change": "Data Change",
    "Do you want to stop this VIP/Early Bird Package?": "Do you want to stop this VIP/Early Bird Package?",
    "Do you want to activate this VIP/Early Bird Package?": "Do you want to activate this VIP/Early Bird Package?",
    "Stop": "Stop",
    "Invalid amount": 'Invalid amount',
    "Edit Special Account": "Edit Early Bird/VIP",
    "Remaining Period": "Remaining Period",
    "Enter Remaining Period": 'Enter Remaining Period',
    "Select MT5 Group": "Select MT5 Group",
    "Edit MT5 Account": 'Edit MT5 Account',
    "Distribute to Shareholder": 'Distribute to Shareholder',
    "package_deleted": "Deleted",
    "package_active": "Active",
    "Contract Commission Percentage": "Contract Commission Percentage",
    "Package Performance": "Package",
    "Commission Percentage": "Commission Percentage",
    "Contract Commission Same Rank Bonus Percentage": "Same Rank Bonus Percentage",
    "Back To Login": "Back To Login",
    "Welcome back,": "Welcome back, ",
    "We are sorry": "We are sorry",
    "The page you're trying to access has restricted access. Please refer to your system administrator.": "The page you're trying to access has restricted access. Please refer to your system administrator.",
    "Profit Sharing Remark": "Profit Sharing Remark",
    "Profit Sharing Bonus List": "Profit Sharing Bonus List",
    "Personal Profit Sharing Bonus": "Personal Profit Sharing Bonus",
    "Group Profit Sharing Bonus": "Group Profit Sharing Bonus",
    "Select Profit Sharing": "Select Profit Sharing",
    "1000 USD Max Lot Per Month": "1000 USD Max Lot Per Month",
    "Enter 1000 USD Max Lot Per Month": "Enter 1000 USD Max Lot Per Month",
    "Live Trade": "Live Trade",
    "Add Live Trade": "Add Live Trade",
    "Edit Live Trade": "Edit Live Trade",
    "No data to export": "No data to export",
    "Txn Hash": "Txn Hash",
    "Enter Txn Hash": "Enter Txn Hash",
    "Received Wallet Address": "Received Wallet Address",
    "Network": "Network",
    "Select Network": "Select Network",
    "BEP20 Chain": "BEP20 Chain",

    "Rank ID": "Rank ID",
    "Rank Image": "Rank Image",
    "Upload Rank Image": "Upload Rank Image",
    "Same Rank": "Same Rank",
    "Reset": "Reset",
    "Edit Custom Rank": "Edit Custom Rank",
    "Add Custom Rank": "Add Custom Rank",
    "Enter Custom Rank Name": "Enter Custom Rank Name",
    "Custom Rank": "Custom Rank",
    "New Custom Rank": "New Custom Rank",
    "Custom Rank Name": "Custom Rank Name",
    "Select Custom Rank": "Select Custom Rank",
    "Enter Lot Size": "Enter Lot Size",
    "Enter Rank ID": "Enter Rank ID",
    "Enter Rank Name": "Enter Rank Name",
    "Enter MT5 Balance Target": "Enter MT5 Balance Target",
    "Enter Personal Sales Target": "Enter Personal Sales Target",
    "Enter Group Sales Target": "Enter Group Sales Target",
    "Enter Rate": "Enter Rate",
    "Select Status": "Select Status",
    "Select Type": "Select Type",
    "Add Rank": "Add Rank",
    "Edit Rank": "Edit Rank",
    "Edit User Group": "Edit User Group",
    "Add User Group": "Add User Group",
    "MT5 Group ID": "MT5 Group ID",
    "User Group Name": "User Group Name",
    "Edit Profit Sharing": "Edit Profit Sharing",
    "Add Profit Sharing": "Add Profit Sharing",
    "Profit Sharing ID": "Profit Sharing ID",
    "Enter Profit Sharing ID": "Enter Profit Sharing ID",
    "Profit Sharing Name": "Profit Sharing Name",
    "Default": 'Default',
    "Enter Profit Sharing Name": "Enter Profit Sharing Name",
    "Label Name": "Name",
    "Yes": "Yes",
    "No": "No",
    "Value": "Value",
    "Type": "Type",
    "Value must equal or larger than 0": "Value must equal or larger than 0",
    "Enter Value": "Enter Value",
    "Select Default": "Select Default",
    "Main USDT Account": "Main USDT Account",
    "Main BSC Account": "Main BSC Account",
    "Main BSC USDT Account": "Main BSC USDT Account",
    "Minimum BNB Transfer Amount": "Minimum BNB Transfer Amount",
    "Main USDT Wallet USDT Balance": "Main USDT Wallet USDT Balance",
    "Main BSC USDT Wallet USDT Balance": "Main BSC USDT Wallet USDT Balance",
    "Main USDT Wallet TRX Balance": "Main USDT Wallet TRX Balance",
    "Enter Withdrawal No.": "Enter Withdrawal No.",
    "Trading Statistic": "Trading Statistic",
    "Coverage Region": "Coverage Region",
    "Edit Coverage Region": "Edit Coverage Region",
    "Add Coverage Region": "Add Coverage Region",
    "Assets Under Management": "Assets Under Management",
    "Total Trades": "Total Trades",
    "Win Trades": "Win Trades",
    "Lose Trades": "Lose Trades",
    "Max Drawdown": "Max Drawdown",
    "Please choose a profit sharing as default": "Please choose a profit sharing as default",
    "Profit Sharing Percentage": "Profit Sharing Percentage",
    "Profit Sharing Same Rank Bonus Percentage": "Profit Sharing Same Rank Bonus Percentage",
    "Member Rank Error": 'Member Rank Error',
    "Edit User Rank": "Edit User Rank",
    "Close": "Close",
    "Deposit MT5": "Deposit MT5",
    "Fiat Section": "Fiat Section",
    "Bank Name": "Bank Name",
    "Bank Account Name": "Bank Account Name",
    "Bank Account No.": "Bank Account No.",
    "Profit Sharing Bonus2" :"Profit Sharing Bonus",
    "View Member Team Hierarchy": "View Member Team Hierarchy",
    "Select Member": "Select Member",
    "Total Transfer (In)": "Total Transfer (In)",
    "Total Transfer (Out)": "Total Transfer (Out)",
    "Copy Strategies": "Copy Strategies",
    'Select Copy Strategies': 'Select Copy Strategies',
    "Transfer Package": "Transfer",
    "Minimum investment amount is $amount": "Minimum investment amount is $amount",
    "5,000 and above": "5,000 and above",
    "Trading Profit (Month)": "Trading Profit (Month)",
    "Date & Time": "Date & Time",
    "Doc No.": "Doc No.",
    "MT5 Transfer to Wallet": "MT5 Transfer to Wallet",
    "Day Count": 'Day Count',
    "Handling Fee": "Handling Fee",
    "View Details": "View Details",
    "Request wallet withdraw": 'Request wallet withdraw',
    "Assets Type": "Assets Type",
    "Target User": "Target User",
    "Internal Transfer": "Transfer",
    "Personal MT5 Withdraw": "Personal MT5 Withdraw",
    "Group MT5 Withdraw": "Group MT5 Withdraw",
    "Member ID": "Member ID",
    "Enter Profit": "Enter Profit",
    "Enter Lot Size": "Enter Lot Size",
    "Daily": "Daily",
    "Weekly": "Weekly",
    "Type": "Type",
    "(NO CAPPED - based on the lot size provided)": "(NO CAPPED - based on the lot size provided)",
    "Run MT5 Profit": "Run MT5 Profit",
    "Confirmation": "Confirmation",
    "This profit did not deduct the 20% for company.": "This profit did not deduct the 20% for company.",
    "eg: mt5 account": "eg: mt5 amount",
    "Block Withdrawal Customer IDs": "Blocked Withdrawal Customer IDs",
}

export default EN;